import React, { Component } from "react";
import FormContent from "./FormContent";
import { Button } from "reactstrap";
// import ConditionsLogicArea from "./ConditionsLogicArea";
// import ColumnsArea from "./ColumnsArea";
import PageName from "../common/PageName.js";

class FormArea extends Component {
  constructor(props) {
    super(props);
    this.state = { ConditionsLogic: "", isSubmit: false };
  }

  render() {

    let { fileFolder, showButtons, formActions, formElements, currentPage } = this.props.parentState;

    // console.log(this.props.parentProps)
    return (
      <div className="col-sm-12 noprint" id="formcontentheight">
        {!formElements[currentPage].dashboard &&
          <PageName
            parentState={this.props.parentState}
            liftGlobalState={this.props.liftGlobalState}
            liftState={this.props.liftState}
            parentProps={this.props.parentProps}
          />
        }
        {formElements[currentPage].dashboard &&
          <div style={{ height: 10 }}></div>
        }


        <FormContent
          parentState={this.props.parentState}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
          parentProps={this.props.parentProps}
        />
      </div>
    );
  }
}

export default FormArea;
